import { useState } from 'react'
import { useAiAccess } from './useAiAccess'
import { budgetBannerFor, dismissBanner, isBannerDismissed } from '../utils/budgetBanner'
import type { BudgetBanner } from '../utils/budgetBanner'

/**
 * The page-top budget banner for a customer: the banner to draw, or null when
 * there is none or it was dismissed this browser session. A dismissal is kept
 * per customer and state, so a worse state (warning to used) shows again.
 */
export const useBudgetBanner = (customer: string | undefined): { banner: BudgetBanner | null; handleDismiss: () => void } => {
  const aiAccess = useAiAccess(customer)
  // Bumped on dismiss so the render reads sessionStorage again; the storage is the state.
  const [, setDismissals] = useState(0)
  const name = customer || ''

  const current = budgetBannerFor(aiAccess)
  const banner = current && !isBannerDismissed(name, current.key) ? current : null

  return {
    banner,
    handleDismiss: () => {
      if (!current) return
      dismissBanner(name, current.key)
      setDismissals((n) => n + 1)
    },
  }
}

export default useBudgetBanner
